// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b74e9149","885":"d1fa757d"}[chunkId] + ".chunk.js";
};